import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
    Modal,
    Typography,
    Button,
    Checkbox,
} from 'antd';
import ExternalLink from '../ExternalLink';
import ModalStatusMessage from '../typograhpy/ModalStatusMessage';
import {
    isEligibleForRefund,
    createCancelledBookingData,
} from '../../utils';
import {
    db,
    COLLECTION_BOOKINGS,
    COLLECTION_BOOKING_DATES_REF,
} from '../../firebase';
import logger from "../../services/logger";


const propTypes = {
    handleCancel: PropTypes.func.isRequired,
    docId: PropTypes.string,
    data: PropTypes.object,
    visible: PropTypes.bool,
};

const { Title, Paragraph } = Typography;

const createInitialState = () => ({
    visible: false,
    confirmLoading: false,
    eligibleForRefund: false,
    submitted: false,
    success: null,
    confirmedCommunication: false,
});

class AdminCancelBookingModal extends Component {
    state = createInitialState();

    componentDidUpdate(prevProps) {
        const { visible, data } = this.props;

        if (visible && prevProps.visible !== visible) {
            this.setState({
                visible,
                eligibleForRefund: isEligibleForRefund(data.date_time),
            });
        }
    }

    handleCheckboxChange = () => {
        this.setState({ confirmedCommunication: !this.state.confirmedCommunication });
    }

    handleOK = async () => {
        const { eligibleForRefund } = this.state;
        const { data, docId } = this.props;
        const cancelledBookingData = createCancelledBookingData(eligibleForRefund);

        this.setState({ confirmLoading: true });

        try {
            const bookingRef = await db.collection(COLLECTION_BOOKINGS).doc(docId);
            const bookingDateTimeRef = await db.collection(COLLECTION_BOOKING_DATES_REF).doc(data.uuid);

            await bookingRef.update(cancelledBookingData);
            await bookingDateTimeRef.delete();

            this.setState({ submitted: true, success: true });
        } catch(e) {
            this.handleError(e);

            this.setState({ submitted: true, success: false });
        }
    }

    handleError = error => {
        const { docId } = this.props;

        logger.error(`Could not cancel booking ${docId} in the dashboard: ` + JSON.stringify(error));
    }

    handleCancel = () => {
        const initialState = createInitialState();

        this.setState({ ...initialState });

        this.props.handleCancel();
    }

    renderSuccess = () => {
        const { success } = this.state;

        return (
            <ModalStatusMessage
                message={ success ? 'Booking successfully cancelled.' : 'There was an error processing this request.' }
                variant={ success ? 'success' : 'error' }
                handleClose={this.handleCancel}
            />
        );
    }

    renderFooter = () => {
        const {
            confirmLoading,
            confirmedCommunication,
            submitted,
        } = this.state;

        if (submitted) return null;

        return (
            <>
                <Button key="back" onClick={this.handleCancel}>
                    Cancel
                </Button>
                <Button
                    key="submit"
                    type="primary"
                    loading={confirmLoading}
                    onClick={this.handleOK}
                    disabled={!confirmedCommunication}
                >
                    Yes, cancel booking
                </Button>
            </>
        );
    }

    render() {
        const {
            visible,
            confirmLoading,
            submitted,
        } = this.state;
        const isManualBooking = _.get(this.props, 'data.manual_booking', false);

        return (
            <Modal
                title={null}
                visible={visible}
                onOk={this.handleOK}
                confirmLoading={confirmLoading}
                onCancel={this.handleCancel}
                footer={this.renderFooter()}
            >
                {
                    submitted
                    ? this.renderSuccess()
                    : <>
                        <Title level={4}>
                            Are you sure you want to cancel this booking?
                        </Title>
                        <br />
                        <Paragraph>
                            You cannot undo this action. Once the booking is cancelled, the timeslot will become free for customers to book.
                        </Paragraph>
                        {
                            !isManualBooking &&
                            <Paragraph>
                                Cancelling this booking will <b>not</b> refund the customer.
                                Payments can only be refunded in the <ExternalLink urlKey="STRIPE">Stripe</ExternalLink> dashboard.
                            </Paragraph>
                        }
                        <Paragraph>
                            To cancel this booking, please confirm the following:
                        </Paragraph>
                        <Checkbox onChange={this.handleCheckboxChange}>
                            {
                                isManualBooking
                                ? 'I would like to cancel this manual booking.'
                                : 'I have spoken to the customer and refunded their payment in Stripe.'
                            }
                        </Checkbox>
                    </>
                }
            </Modal>
        );
    }
}

AdminCancelBookingModal.propTypes = propTypes;

export default AdminCancelBookingModal;
